export default "__VITE_ASSET__DXh3ldUk__"